// extracted by mini-css-extract-plugin
module.exports = {"replies":"tweet-replies_replies__1t31E","link":"tweet-replies_link__SSKKi","text":"tweet-replies_text__9iorF"};